module.exports = __webpack_public_path__ + "static/London-43eaecbd406ea2aeda01582c590a0808.png";